import { useState } from 'react';
import { Card, CardContent, Typography, Stack, Chip, Divider, Button, Grid } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { useTranslation } from 'react-i18next';

import MoreTimeIcon from '@mui/icons-material/MoreTime';
import DateRangeIcon from '@mui/icons-material/DateRange';
import EventNoteIcon from '@mui/icons-material/EventNote';
import DescriptionIcon from '@mui/icons-material/Description';

export const ItemCard = ({ item, onDelete, onEdit }) => {
    const { t } = useTranslation();
    const [loadingDelete, setLoadingDelete] = useState(false);

    const handleDelete = async () => {
        setLoadingDelete(true);
        onDelete(item.combination_rule_id).finally(() => {
            setLoadingDelete(false);
        });
    };

    return (
        <Card key={item.combination_rule_id}>
            <CardContent>
                <Grid container spacing={1}>
                    <Grid>
                        <DescriptionIcon color="primary" />
                    </Grid>
                    <Grid>
                        <Typography color="primary">
                            {t('settings.combinations.dialog.inputs.name')}: {item.name}
                        </Typography>
                    </Grid>
                </Grid>
                <Grid container spacing={1}>
                    <Grid>
                        <DescriptionIcon color="primary" />
                    </Grid>
                    <Grid>
                        <Typography color="primary">
                            {t('settings.combinations.dialog.inputs.description')}:{' '}
                            {item.description}
                        </Typography>
                    </Grid>
                </Grid>
                <Divider sx={{ mt: 1, mb: 1 }} />
                <Grid container spacing={1} sx={{ mt: 1 }}>
                    <Grid>
                        <MoreTimeIcon color="primary" />
                    </Grid>
                    <Grid>
                        <Typography color="primary">
                            {t('settings.combinations.dialog.summary.overtime_rules')}{' '}
                        </Typography>
                    </Grid>
                </Grid>
                <Grid size={12}>
                    <Stack direction="row" spacing={1} useFlexGap sx={{ flexWrap: 'wrap', ml: 4 }}>
                        {item.overtime_rules.map(overtime => (
                            <Chip
                                key={`ch1-${overtime.overtime_rule_id}`}
                                label={overtime.name}
                                color="warning"
                                variant="outlined"
                            />
                        ))}
                    </Stack>
                </Grid>
                <Grid container spacing={1} sx={{ mt: 1 }}>
                    <Grid>
                        <DateRangeIcon color="primary" />
                    </Grid>
                    <Grid>
                        <Typography color="primary">
                            {t('settings.combinations.dialog.summary.zones_rules')}{' '}
                        </Typography>
                    </Grid>
                </Grid>
                <Grid size={12}>
                    <Stack direction="row" spacing={1} useFlexGap sx={{ flexWrap: 'wrap', ml: 4 }}>
                        {item.zones.map(zone => (
                            <Chip
                                key={`ch2-${zone.zone_id}`}
                                label={zone.name}
                                color="warning"
                                variant="outlined"
                            />
                        ))}
                    </Stack>
                </Grid>
                <Grid container spacing={1} sx={{ mt: 1 }}>
                    <Grid>
                        <EventNoteIcon color="primary" />
                    </Grid>
                    <Grid>
                        <Typography color="primary">
                            {t(
                                'settings.combinations.dialog.summary.schedule_desviation_rules',
                            )}{' '}
                        </Typography>
                    </Grid>
                </Grid>
                <Grid size={12}>
                    <Stack direction="row" spacing={1} useFlexGap sx={{ flexWrap: 'wrap', ml: 4 }}>
                        {item.schedule_desviation_rules.map(schedule_desviation => (
                            <Chip
                                key={`ch3-${schedule_desviation.schedule_desviation_rule_id}`}
                                label={schedule_desviation.name}
                                color="warning"
                                variant="outlined"
                            />
                        ))}
                    </Stack>
                </Grid>
                {onDelete != null && (
                    <Button
                        loading={loadingDelete}
                        loadingPosition="start"
                        startIcon={<DeleteIcon />}
                        variant="contained"
                        color="secondary"
                        onClick={handleDelete}
                    >
                        {t('settings.combinations.dialog.buttons.delete')}
                    </Button>
                )}

                {onEdit != null && (
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => onEdit(item)}
                    >
                        {t('settings.combinations.dialog.buttons.edit')}
                    </Button>
                )}
            </CardContent>
        </Card>
    );
};
